/** Pipeline-specific formatting utilities. */

import type { PipelineExecutionStatus, StepExecutionStatus, PipelineTriggerSource } from "../types/pipeline";

const STATUS_LABELS: Record<PipelineExecutionStatus, string> = {
  pending: "等待中",
  running: "运行中",
  completed: "已完成",
  failed: "失败",
  cancelled: "已取消",
};

const STEP_STATUS_LABELS: Record<StepExecutionStatus, string> = {
  pending: "等待中",
  running: "执行中",
  completed: "已完成",
  failed: "失败",
  skipped: "已跳过",
};

const TRIGGER_SOURCE_LABELS: Record<PipelineTriggerSource, string> = {
  manual: "手动触发",
  matter_event: "事项事件",
  scheduled: "定时触发",
  api: "API 调用",
};

export function getPipelineStatusLabel(status: PipelineExecutionStatus): string {
  return STATUS_LABELS[status] ?? status;
}

export function getStepStatusLabel(status: StepExecutionStatus): string {
  return STEP_STATUS_LABELS[status] ?? status;
}

export function getTriggerSourceLabel(source: PipelineTriggerSource): string {
  return TRIGGER_SOURCE_LABELS[source] ?? source;
}

/** Format duration in seconds to human-readable string (e.g., "2分30秒", "1小时15分"). */
export function formatDuration(seconds: number | null): string {
  if (seconds == null || seconds < 0) return "-";
  if (seconds < 60) return `${Math.round(seconds)}秒`;
  const mins = Math.floor(seconds / 60);
  const secs = Math.round(seconds % 60);
  if (mins < 60) return secs > 0 ? `${mins}分${secs}秒` : `${mins}分`;
  const hours = Math.floor(mins / 60);
  const remainMins = mins % 60;
  return remainMins > 0 ? `${hours}小时${remainMins}分` : `${hours}小时`;
}
